// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalRoot_container__3ALvS","background":"ModalRoot_background__1b7jH"};